export const backgroundColors: string[] = [
  '#16A085',
  '#27AE60',
  '#ff6666',
  '#664c00',
  '#ffeb99',
  '#006600',
  '#005959',
  '#262626',
  '#0066cc',
  '#E66614E0',
  '#39AE47',
  '#3357FF',
  '#F1C40F',
  '#9B59B6',
  '#E74C3C',
  '#1ABC9C',
  '#2ECC71',
  '#3498DB',
  '#E67E22',
  '#ECF0F1',
  '#95A5A6',
  '#34495E',
  '#7F8C8D',
  '#BDC3C7',
  '#2980B9',
  '#8E44AD',
  '#C0392B',
  '#D35400',
  '#F39C12',
  '#BDC3C7',
  '#7F8C8D',
  '#FF6F61',
  '#6B5B95',
  '#88B04B',
  '#F7CAC9',
  '#92A8D1',
  '#955251',
  '#B565A7',
  '#009B77',
  '#DD4124',
  '#D65076',
  '#45B8AC',
  '#EFC050',
  '#5B5EA6',
  '#9B2335',
  '#DFCFBE',
  '#55B4B0',
  '#E15D44',
  '#7FCDCD',
  '#BC243C',
  '#C3447A',
  '#98B4D4',
  '#6C4F3D',
  '#C94C4C',
  '#FFA07A',
  '#20B2AA',
  '#778899',
  '#B0C4DE'
];